export default __webpack_public_path__ + "static/4-83e6625233c8484050b244c75dce570a.jpeg";